export default function Resume() {
  return (
    <section id="resume" className="bg-gray-950 py-12 px-6 text-white text-center">
      <h3 className="text-3xl text-red-500 font-bold mb-6">Resume</h3>
      <a
        href="/NANGUNOORI CHANDU.pdf"
        download
        className="bg-red-600 px-6 py-3 rounded hover:bg-red-700 transition"
      >
        Download My Resume
      </a>
    </section>
  );
}
